import React from "react";
import constants from "./constants";
import { Icon } from "@iconify/react";

const Button = (props) => {
  const defaultClasses = `bg-${constants.primaryColorClass} \
    hover:bg-${constants.darkPrimaryColorClass} text-white \
    rounded-md  text-center ${props.disabled ? "opacity-50 cursor-not-allowed" : ""} \
    ${props.size === "small" ? "text-xs px-4 py-1" : "px-5 py-2"} \
  `;

  if (props.href) {
    return (
      <a {...props} className={`${defaultClasses} ${props.className}`}>
        {props.children}
      </a>
    );
  }

  return (
    <button
      {...props}
      className={`${defaultClasses} ${props.className}`}
      disabled={props.disabled || props.loading}
    >
      {props.loading ? (
        <Icon icon="tabler:loader-2" className="animate-spin" />
      ) : (
        props.children
      )}
    </button>
  );
};

export default Button;
